/**
 * Timesheet generation (ROADMAP B4, Karan). Not built yet.
 *
 * A real card rather than no card, for the reason the carcass report has
 * one: a tool with no renderer shows "Tool not found or not yet available",
 * which reads as a fault and tells nobody what is coming.
 */
export default function TimesheetGeneratorCard() {
    return (
        <div className="space-y-4">
            <div className="ui-card p-4">
                <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-extrabold text-[15px]">Not built yet</h3>
                    <span className="pill bg-sle-tint text-sle">Coming soon</span>
                </div>
                <p className="text-ink-soft text-[13px] mt-2">
                    Each pay period's timecard is rebuilt by hand in Google Sheets, once
                    per person. The layout is not a free choice — day columns, day-of-week
                    labels, a weekly subtotal after every Saturday, a grand total — it
                    follows entirely from the period's start and end dates. That makes it
                    something to generate rather than retype.
                </p>
            </div>

            <div className="ui-card p-4">
                <div className="eyebrow mb-2">What it will do</div>
                <ul className="text-[13px] text-ink-soft space-y-1.5 list-disc pl-5">
                    <li>
                        Add the next period's tab to each person's existing spreadsheet,
                        named the way they already are (<code>916-93026</code>).
                    </li>
                    <li>
                        Copy each person's own previous tab as the template, so per-person
                        variation carries over and nothing drifts from what they already use.
                    </li>
                    <li>
                        Lay out the columns and formulas from the period dates — semi-monthly
                        periods run 13 to 16 days, so the week boundaries land somewhere
                        different every time.
                    </li>
                </ul>
                <p className="text-[12px] text-ink-faint mt-3">
                    <strong>Entry does not move.</strong> Everyone keeps their existing
                    sheet, link and permissions; only Karan's side changes.
                </p>
            </div>

            <div className="ui-card p-4">
                <div className="eyebrow mb-2">Why it is worth doing</div>
                <p className="text-[13px] text-ink-soft">
                    An audit of 38 tabs found 15 with a day column left out of every weekly
                    subtotal, one omitting a whole week from the grand total, and 20 with
                    mislabelled headers. <strong>No hours were actually lost</strong> — every
                    affected day happened to be blank, so all 38 totals are correct. It is a
                    latent fault rather than a live miscount: a Saturday worked on a week
                    boundary would vanish from both its weekly subtotal and the period total,
                    silently. Generating the tab removes the whole class.
                </p>
                <p className="text-[12px] text-ink-faint mt-3">
                    The historical tabs are left alone — the totals are right, and rewriting
                    last year's timecards is risk without benefit. Blocked on per-person
                    access control (A6), since the records are per-person. Seasonal staff are
                    recorded differently, on a field supervisor's sheet, and are a separate
                    build.
                </p>
            </div>
        </div>
    );
}
